<form [formGroup]="specBelastingBox2FormGroup">
    <ng-container formGroupName="specificatieBelastingBox2">
        <ng-container formGroupName="opbouw">
            <ng-container *ngIf="this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.voorkomingBox2 !== undefined &&  this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.voorkomingBox2! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Belasting box 2 voor voorkoming
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="box2VoorVoorkoming"
                                id="box2VoorVoorkoming"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.voorkomingBox2 !== undefined &&  this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.voorkomingBox2! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Af: Voorkoming dubbele belasting (te verrekenen)
                    </div>
                    <div></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="voorkomingBox2"
                                id="voorkomingBox2"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.berekendeIB !== undefined &&  this.specBelastingBox2.specificatieBelastingBox2?.opbouw?.berekendeIB! > 0">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Belasting box 2
                    </div>
                    <div class="flex-item-ruimte-dialog"></div>
                    <div>
                        <snelstart-ui-number-form-control
                                formControlName="berekendeIB"
                                id="berekendeIB"
                                class="custom-input-150"
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</form>

